import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable, Subject } from 'rxjs';
import { Attachment, Invoice, InvoiceBidsPrice, InvoiceList } from '../../../../../../core/model/invoice.model';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {

  public refreshInvoice$ = new Subject();
  private apiUrl = '/invoice';

  constructor(
    private _httpService: FlamingoHttpService,
  ) {
  }

  getInvoiceBids(dto: {
    installments: Array<{ amount: number; dueDate: string }>;
    averagePaymentDelay: number;
    sellerTaxCodePrefix: string;
    sellerTaxCode: string;
    debtorTaxCodePrefix: string;
    debtorTaxCode: string;
  }): Observable<InvoiceBidsPrice> {
    return this._httpService.post(`${this.apiUrl}/bids`, dto);
  }

  public list(
    page?: number,
    pageSize?: number,
    sort?: string,
    sortOrder?: string,
    filter?: string,
  ): Observable<InvoiceList> {
    const params = new HttpParams()
      .set('page', page ? `${page}` : '0')
      .set('pageSize', pageSize ? `${pageSize}` : '10')
      .set('sort', sort ? sort : 'createdAt')
      .set('sortOrder', sortOrder ? sortOrder : 'DESC')
      .set('filter', filter ? filter : '');

    return this._httpService.get(this.apiUrl, params);
  }

  public create(invoice: FormData): Observable<Invoice> {
    return this._httpService.postFormData(this.apiUrl, invoice);
  }

  public edit(invoice: FormData, identifier: string): Observable<Invoice> {
    return this._httpService.putFormData(`${this.apiUrl}/${identifier}`, invoice);
  }

  public get(identifier: string): Observable<Invoice> {
    return this._httpService.get(`${this.apiUrl}/${identifier}`);
  }

  public delete(identifier: string): Observable<Invoice> {
    return this._httpService.delete(`${this.apiUrl}/${identifier}`);
  }

  public downloadInvoice(identifier: string): Observable<any> {
    return this._httpService.getUrl(`${this.apiUrl}/${identifier}/download`);
  }

  public checkPublish(invoiceId: string): Observable<any> {
    return this._httpService.get(`${this.apiUrl}/${invoiceId}/publish/check`);
  }

  public publish(identifier: string): Observable<any> {
    return this._httpService.post(`${this.apiUrl}/${identifier}/publish`);
  }

  public createAttachment(attachment: FormData, invoiceId: string): Observable<Attachment> {
    const url = `${this.apiUrl}/${invoiceId}/attachment`;
    return this._httpService.postFormData(url, attachment);
  }

  public uploadXML(data: FormData): Observable<Invoice> {
    const url = `${this.apiUrl}/xml`;
    return this._httpService.postFormData(url, data);
  }

  public updateAttachment(
    body: any,
    invoiceId: string,
    attachmentId: number,
  ): Observable<Attachment> {
    const url = `${this.apiUrl}/${invoiceId}/attachment/${attachmentId}`;
    return this._httpService.put(url, body);
  }

  public updateAttachmentFile(
    data: FormData,
    invoiceId: string,
    attachmentId: number,
  ): Observable<Attachment> {
    const url = `${this.apiUrl}/${invoiceId}/attachment/${attachmentId}/file`;
    return this._httpService.putFormData(url, data);
  }

  public deleteAttachment(attachment: Attachment, invoiceId: string): Observable<any> {
    const url = `${this.apiUrl}/${invoiceId}/attachment/${attachment.id}`;
    return this._httpService.delete(url, null);
  }

  public downloadAttachment(invoiceId: string, attachmentId: number): Observable<any> {
    return this._httpService.getUrl(`${this.apiUrl}/${invoiceId}/attachment/${attachmentId}`);
  }
}
